(function ($) {
    function new_map($el) {
        var $markers = $el.find('.marker');
        var args = {
            zoom: 19,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#e9e9e9"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 29
                        },
                        {
                            "weight": 0.2
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 18
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        },
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#dedede"
                        },
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#ffffff"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "saturation": 36
                        },
                        {
                            "color": "#333333"
                        },
                        {
                            "lightness": 40
                        }
                    ]
                },
                {
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#f2f2f2"
                        },
                        {
                            "lightness": 19
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#fefefe"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#fefefe"
                        },
                        {
                            "lightness": 17
                        },
                        {
                            "weight": 1.2
                        }
                    ]
                }
            ]
        };
        var map = new google.maps.Map($el[0], args);
        map.markers = [];
        $markers.each(function () {
            add_marker($(this), map);
        });
        center_map(map);
        current_window = null;
        add_cluster(map, map.markers);

        google.maps.event.addListener(map, 'zoom_changed', function() {
            var zoomLevel = map.getZoom();
            if (zoomLevel >= 20) {
                map.setZoom(20);
            }
        });
        return map;
    }


    function add_marker($marker, map) {
        var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
        var marker = new google.maps.Marker({
            position: latlng,
            map: map
        });
        map.markers.push(marker);
        if ($marker.html()) {
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html(),
                //disableAutoPan: true,
            });
            google.maps.event.addListener(marker, 'click', function () {
                if(current_window != null)
                {
                    //console.log( current_window );
                    current_window.close();
                }
                infowindow.open(map, marker);
                current_window = infowindow;
            });
        }
    }


    function center_map(map) {
        var lng_lats = [];
        var bounds = new google.maps.LatLngBounds();
        $.each(map.markers, function (i, marker) {
            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
            lng_lats.push( [marker.position.lat(), marker.position.lng()]);
            bounds.extend(latlng);
        });

        //console.log( lng_lats );

        if (map.markers.length == 1) {
            map.setCenter(bounds.getCenter());
            // map.setZoom(16);
        }
        else {
            //console.log( 'in the else');
            map.setCenter(bounds.getCenter());
            // map.fitBounds(bounds);
            var zoom = map.getZoom();
            map.setZoom(zoom > 8 ? 6 : zoom);
        }
    }

    function add_cluster(map, markers)
    {
        var mc = new MarkerClusterer(map, markers,
            {
                gridSize: 40,
                maxZoom: 20,
                zoomOnClick: true,
                minimumClusterSize: 4,
                imagePath: "/app/themes/hailstone/img/layout/m/m"
            });

    }

    var map = null;
    $(document).ready(function () {
        $('.acf-map').each(function () {
            map = new_map($(this));
        });
    });
})(jQuery);